"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var IST = _interopRequireWildcard(require("./incomeSourceTypes"));

var ISST = _interopRequireWildcard(require("./incomeSourceSubTypes"));

var _IST$BUSINESS$IST$EMP;

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = (_IST$BUSINESS$IST$EMP = {}, _defineProperty(_IST$BUSINESS$IST$EMP, IST.BUSINESS, [ISST.INDEPENDENT_CONTRACTOR, ISST.RENTAL_PROPERTY]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.EMPLOYEE, [ISST.FULL_TIME, ISST.PART_TIME, ISST.TEMPORARY]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.GOVERNMENT, [ISST.UNEMPLOYMENT, ISST.SOCIAL_SECURITY, ISST.SUPPLEMENTAL_SECURITY_INCOME, ISST.SOCIAL_SECURITY_DISABILITY_INSURANCE, ISST.SNAP, ISST.TANF, ISST.SECTION_8, ISST.LIFELINE_PHONE, ISST.LIHEAP, ISST.CHIP, ISST.VA_DISABILITY, ISST.OTHER_GOVERNMENT_ASSISTANCE]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.INVESTMENT, [ISST.DIVIDENDS, ISST.INTEREST]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.RESIDUALS_ROYALTIES, [ISST.RESIDUALS, ISST.ROYALTIES]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.OTHER, []), _defineProperty(_IST$BUSINESS$IST$EMP, IST.OUTSIDE_CONTRIBUTOR, [ISST.CROWD_FUNDING, ISST.COMMUNITY_ORGANIZATION, ISST.FAMILY, ISST.FRIEND]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.RETIREMENT, [ISST.IRA, ISST.PENSION, ISST.PLAN_401K, ISST.PLAN_403B, ISST.PROFIT_SHARING_PLAN, ISST.ROTH_IRA]), _defineProperty(_IST$BUSINESS$IST$EMP, IST.SUPPORT, [ISST.ALIMONY, ISST.MAINTENANCE, ISST.FAMILY_SPOUSAL_SUPPORT, ISST.CHILD_SUPPORT, ISST.DIVORCE_SETTLEMENT, ISST.PROPERTY_SETTLEMENT]), _IST$BUSINESS$IST$EMP);

exports["default"] = _default;